export interface VisorArchivoProps {
  nombre: string;
  tipoMime: string;
  /** Ruta que lo sirve para mostrar (`/adjuntos/{id}/descarga?ver=true`, `inline`). */
  rutaVer: string;
  /** Ruta que lo baja (`attachment`). */
  rutaDescarga: string;
}

/** Tipos que el navegador muestra solo (HEIC sólo Safari: se ofrece abrir o descargar). */
const IMAGENES_VISIBLES = ["image/jpeg", "image/png", "image/webp"];

const claseLink = "text-primario underline-offset-2 hover:underline";

/** Un PDF o una foto mostrado en la página, con "Abrir en otra pestaña" y "Descargar" (en el celular el PDF embebido
 * puede no verse entero: abrirlo en otra pestaña usa el visor del teléfono). */
export function VisorArchivo({ nombre, tipoMime, rutaVer, rutaDescarga }: VisorArchivoProps) {
  const esPdf = tipoMime === "application/pdf";
  const esImagen = IMAGENES_VISIBLES.includes(tipoMime);
  return (
    <div className="flex flex-col gap-2">
      {esPdf && <iframe title={`Vista de «${nombre}»`} src={rutaVer} className="h-[70vh] w-full rounded-control border border-borde bg-superficie-2" />}
      {esImagen && <img src={rutaVer} alt={nombre} className="max-h-[70vh] w-full rounded-control border border-borde bg-superficie-2 object-contain" />}
      {!esPdf && !esImagen && <p className="text-chico text-texto-suave">{`«${nombre}» no se puede mostrar acá: abrilo o descargalo.`}</p>}
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        <a href={rutaVer} target="_blank" rel="noreferrer" className={claseLink}>
          Abrir en otra pestaña
        </a>
        <a href={rutaDescarga} download className={`${claseLink} truncate`}>
          {`Descargar «${nombre}»`}
        </a>
      </div>
    </div>
  );
}
